import {
  Progress as _Progress,
  ProgressProps as _ProgressProps
} from "reactstrap";

export const Progress = _Progress;
export type ProgressProps = _ProgressProps;
